import { FC } from 'react';
import ApproveRKY from './ApproveRKY';
import ConfirmDelete from './ConfirmDelete';
import ContactWorker from './ContactWorker';
import EnterInformation from './EnterInformation';
import GanttChart from './GanttChart';
import ModalAddHistoryWork from './ModalAddHistoryWork';
import ModalEditCheckInTime from './ModalEditCheckInTime';
import ModalOutputRKY from './ModalOutputRKY';
import ModalScheduleConfirmation from './ModalScheduleConfirmation';
import ModalUploadImage from './ModalUploadImage';
import SectionStyled from './styles';
import ApproveRY from './ApproveRY';
import DeleteAppointment from './DeleteAppointment';
const ModalMock: FC = () => {
  return (
    <SectionStyled>
      <ConfirmDelete />
      <DeleteAppointment />
      <ApproveRKY />
      <EnterInformation />
      <ModalEditCheckInTime />
      <ModalUploadImage />
      <ModalOutputRKY />
      <ContactWorker />
      <ModalScheduleConfirmation />
      <ModalAddHistoryWork />
      <ApproveRY />
      <GanttChart />
    </SectionStyled>
  );
};

export default ModalMock;
